<template>
<div class="ui segments">

  <div class="ui segment">
    <div class="ui breadcrumb">
      <router-link :to="{name:'home'}" class="section">Sākums</router-link>
      <span class="divider">/</span>
      <div class="active section">Pirkumu grozs</div>
    </div>
  </div>

  <cart-steps step="3" :confirmed="order && order.status"></cart-steps>
  <div v-if="order" class="ui attached segment">
    <div class="ui warning icon message" v-if="order.paysera_stat == 2" >
      <i class="info circle icon"></i>
      <div class="content">
        <div class="header">
          Informācijai
        </div>
        <p>Samaksas process vēl nav galīgi pabeigts. Atkarībā no bankas parasti šis process aizņem dažas stundas. <br> Tiklīdz samaksa tiks saņemta, Jūs saņemsiet e-pastu no maksājumu sistēmas un Jūsu veiktais pasūtījums būs apskatāms sadaļā "Gaida piegādi".</p>
      </div>
    </div>
    <h4>Paldies par pasūtījumu!</h4>
    <p v-if="!order.only_services">Jūsu pasūtījumu plānots piegādāt <b>{{order.delivery_date}}</b> uz:

    <b>{{order.address}}</b>
    </p>
    <p>Ja rodas steidzami jautājumi, sazinieties ar pasūtījumu centru pa tel. <a href="tel:0037120010800<">200 108 00</a></p>
    <p v-if="!order.only_services">Piegādes pavaddokuments tiks nosūtīts uz jūsu e-pastu piegādes brīdī.</p>
    <p v-if="!order.only_services && order.payment_type == 3">Lūdzu atstājiet kurjeram iespējami precīzu naudu -
    <b v-if="!order.only_services && user.balance < 0">{{positiveBalance}}</b>
    <b v-if="!order.only_services && user.balance >=0">{{order.total_amount_with_bail_and_vat}}</b> <b>&euro;</b></p>
	<p v-f="order.bonus > 0" style="color:#21BA45">Jūs izmantojāt savu uzkrāto bonusu citu produktu iegādei EUR {{order.bonus}}. Maksimāli bonusu var izmantot 30% apmērā no citu produktu summas.</p>


    <div class="ui container">
      <button @click="$router.push({name: 'goods'})" class="ui right floated custom_brown button">Izveidot jaunu pasūtījumu</button>
      <div class="ui clearing hidden divider"></div>
    </div>
  </div>


</div>
</template>

<script>
import CartSteps from './CartSteps'

export default {
  components: {
    CartSteps
  },
  computed: {
    user() {
      return this.$store.state.userStore.user
    },
    order() {
      return this.$store.state.orderStore.order
    },
    positiveBalance(){
      var balance = this.user.balance * (-1);

      return balance.toFixed(2);
    }
  },

  activated: function() {

    //preload data

    if(this.$route.params.orderid) {

        this.$store.dispatch('loadOrder', this.$route.params.orderid).then((response) => {

            this.$store.dispatch('loadOrderWaitingForDelivery'); //reload number of orders waiting for delivery

        }).catch((error) => {
          //if order not found then go to home page

          this.$router.push({
              name: 'home'
          });
        });
    }


  },
  mounted() {
    let adScript1 = document.createElement('script');
	adScript1.async = true;
    adScript1.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-3XFB1Z2Y3Z');
    document.head.appendChild(adScript1);
	let adScript2 = document.createElement('script');
	adScript2.innerHTML = 'window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag("js", new Date()); gtag("config", "G-3XFB1Z2Y3Z");';
	document.head.appendChild(adScript2);
  },
  methods: {

  }
}
</script>




<style>
p{
  margin: 0 0 0.53em !important
}
</style>



// WEBPACK FOOTER //
// CartConfirmationPage.vue?5654b435